import React, { useState, useEffect } from 'react';
import Counter from './Counter';
import { useGame } from '../context/GameContext';

function YgoPlayer() {
  const startThousands = 8;
  const startHundreds = 0;
  const startTens = 0;
  const startOnes = 0;

  const [thousands, setThousands] = useState(startThousands);
  const [hundreds, setHundreds] = useState(startHundreds);
  const [tens, setTens] = useState(startTens);
  const [ones, setOnes] = useState(startOnes);

  const { reset } = useGame();

  useEffect(() => {
    if(reset) {
        setThousands(startThousands);
        setHundreds(startHundreds);
        setTens(startTens);
        setOnes(startOnes);
    }
  }, [reset]);

  const calcTotal = () : number => {
    let total: number = thousands * 1000;
    total += hundreds * 100;
    total += tens * 10;
    total += ones;

    return total;
  }

  const halveTotal = () : void => {
    let halve: number = calcTotal() / 2;

    setThousands( Math.abs(Math.floor(halve/1000)%10) );
    setHundreds( Math.abs(Math.floor(halve/100)%10) );
    setTens( Math.abs(Math.floor(halve/10)%10) );
    setOnes( Math.abs(Math.floor(halve/1)%10) );
  }

  const updateThousands = (value : number) : void => {
    if(value < 0) {
      value = 0;
    }
    setThousands(value);
  }

  const updateHundreds = (value : number) : void => {
    if(hundreds === 9 && value === 10) {
      updateThousands(thousands + 1);
      setHundreds(0)
    }
    else if(hundreds === 0 && value === -1) {
      updateThousands(thousands - 1);
      setHundreds(9);
    }
    else {
      setHundreds(value);
    }
  }

  const updateTens = (value : number) : void => {
    if(tens === 9 && value === 10) {
      updateHundreds(hundreds + 1);
      setTens(0);
    }
    else if(tens === 0 && value === -1) {
      updateHundreds(hundreds - 1);
      setTens(9);
    }
    else {
      setTens(value);
    }
  }

  const updateOnes = (value : number) : void => {
    if(ones === 9 && value === 10) {
      updateTens(tens + 1);
      setOnes(0);
    }
    else if(ones === 0 && value === -1) {
      updateTens(tens - 1);
      setOnes(9);
    }
    else {
      setOnes(value);
    }
  }

  return(
    <div className = "player">
      <div className = "playerCounters">
        <Counter 
          value = {thousands}
          updateFunction = {updateThousands}
          incrementValue = {1}
          decrementValue = {1}
        />
        <Counter 
          value = {hundreds}
          updateFunction = {updateHundreds}
          incrementValue = {1}
          decrementValue = {1}
        />
        <Counter 
          value = {tens}
          updateFunction = {updateTens}
          incrementValue = {1}
          decrementValue = {1}
        />
        <Counter 
          value = {ones}
          updateFunction = {updateOnes}
          incrementValue = {1}
          decrementValue = {1}
        />
      </div>
      <div className = "halveTotal">
        <span className = "App-icon" onClick = {() => {halveTotal()}}>
          ½
        </span>
      </div>
    </div>
  );
}

export default YgoPlayer;
